import React from 'react';
import { Mail, Phone, ExternalLink, Database, Layers } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Support = () => {
  const { t } = useLanguage();
  const texts = t('support');

  const supportSections = [
    {
      title: texts.dataAccountAssistance || 'Data & Account Assistance',
      description: texts.dataAccountDesc || 'Questions around customer data, loan records, or account management. Mahendra is available during business hours to help resolve any operational queries.',
      icon: Database,
      contacts: [
        {
          label: texts.primaryContact || 'Primary Contact',
          name: 'Mahendra Seervi',
          phone: '+91 9939946023',
          email: 'mahendras00b@gmail.com'
        }
      ]
    },
    {
      title: texts.platformTechnicalSupport || 'Platform & Technical Support',
      description: texts.platformTechnicalDesc || 'Facing login issues, app errors, or performance concerns? Reach out to the Seervi Tech Labs engineering desk for quick resolution.',
      icon: Layers,
      contacts: [
        {
          label: texts.technicalDesk || 'Technical Desk',
          name: 'Seervi Tech Labs',
          phone: '+91 94625 40114',
          email: 'seervitechlabs@gmail.com'
        }
      ],
      website: {
        label: 'Visit Support Center',
        url: 'https://seervitechlabs.com/'
      }
    }
  ];

  return (
    <div>
      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <h2 className="card-title" style={{ marginBottom: 0 }}>{texts.title || 'Support Hub'}</h2>
          <p className="support-page-subtitle">
            {texts.subtitle || 'We are always close by when you need us. Choose the contact option that best fits your query—whether it is a data clarification or a deeper technical issue.'}
          </p>
        </div>
      </div>

      <div className="support-sections-grid">
        {supportSections.map((section) => {
          const Icon = section.icon;
          return (
            <div key={section.title} className="card support-section-card">
              <div className="support-section-head">
                <div className="support-section-icon">
                  <Icon size={24} />
                </div>
                <div>
                  <h3 className="support-section-title">{section.title}</h3>
                  <p className="support-section-desc">{section.description}</p>
                </div>
              </div>

              <div className="support-contacts">
                {section.contacts.map((contact) => (
                  <div key={contact.email} className="support-contact-card">
                    <div className="support-contact-label">{contact.label}</div>
                    <div className="support-contact-name">{contact.name}</div>
                    <div className="support-contact-links">
                      <a
                        href={`tel:${contact.phone.replace(/\s+/g, '')}`}
                        className="support-contact-link support-contact-phone"
                      >
                        <Phone size={16} />
                        {contact.phone}
                      </a>
                      <a
                        href={`mailto:${contact.email}`}
                        className="support-contact-link support-contact-email"
                      >
                        <Mail size={16} />
                        {contact.email}
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              {section.website && (
                <a
                  href={section.website.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="support-website-btn"
                >
                  <ExternalLink size={16} />
                  {section.website.label}
                </a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Support;
